import { j as o } from "../../../../jsx-runtime.BREq8dyb.js";
import { Box as d, Stack as e, Typography as i } from "@mui/joy";
import { d as n } from "../../../../lodash.CbaCmyiN.js";
import { memo as c, Fragment as h } from "react";
import "../../../../Prepper.Bv7VECW1.js";
import "../../../DqAlert/DqAlert.js";
import "../../DqAudienceRulesBuilder.js";
import "../../models.js";
import "../../../../react-click-away-listener.BrTEM9EK.js";
import "../../../DqDomainsEditor/DqDomainsEditor.js";
import "../../../DqEmptyData/DqEmptyData.js";
import "../../../DqFloatingLabelInput/DqFloatingLabelInput.js";
import "../../../DqFloatingLabelSelect/DqFloatingLabelSelect.js";
import "../../../DqIcon/DqIcon.js";
import "../../../DqId/DqId.js";
import "@decentriq/hooks";
import "@decentriq/utils";
import "../../../../DqInlineEditor.BguPN4Ku.js";
import "../../../DqLoader/DqLoader.js";
import "../../../DqOtpInput/DqOtpInput.js";
import "../../../DqParticipantsEditor/DqParticipantsEditor.js";
import "../../../DqSidePanel/DqSidePanel.js";
import "../../../DqSidePanel/DqSidePanelActions.js";
import "../../../DqSidePanel/DqSidePanelContent.js";
import "../../../DqSidePanel/DqSidePanelTitle.js";
import "../../../DqSidePanel/DqSidePanelTitleToolbar.js";
import "../../../DqSortableAccordion/DqSortableAccordion.js";
import "../../../DqSortableAccordionDetails/DqSortableAccordionDetails.js";
import "../../../DqSortableAccordionGroup/DqSortableAccordionGroup.js";
import "../../../DqSortableAccordionSummary/DqSortableAccordionSummary.js";
import "../../../DqSpinner/DqSpinner.js";
import "@fortawesome/pro-light-svg-icons";
import "@fortawesome/react-fontawesome";
import "../../../Loader/Loader.js";
import { mapAudienceConditionToPresentation as a } from "../../config.js";
import x from "../CombinatorChip/CombinatorChip.js";
import p from "../../../DqCard/DqCard.js";
const j = c(({
  audienceTree: s
}) => /* @__PURE__ */ o.jsxs(d, { width: "100%", children: [
  /* @__PURE__ */ o.jsx(e, { children: /* @__PURE__ */ o.jsxs(p, { children: [
    /* @__PURE__ */ o.jsx(i, { level: "body-sm", startDecorator: /* @__PURE__ */ o.jsx("b", { children: "Audience 1:" }), textColor: "inherit", children: s.name }),
    s.filters?.filters.map((r) => /* @__PURE__ */ o.jsxs(e, { mt: 1, spacing: 0, children: [
      /* @__PURE__ */ o.jsx(i, { level: "body-sm", startDecorator: /* @__PURE__ */ o.jsx("b", { children: "Attribute:" }), textColor: "inherit", children: n(r.attribute ?? "") }),
      /* @__PURE__ */ o.jsx(i, { level: "body-sm", startDecorator: /* @__PURE__ */ o.jsx("b", { children: "Condition:" }), textColor: "inherit", children: (r.condition && a[r.condition]) ?? r.condition }),
      r.values?.length ? /* @__PURE__ */ o.jsx(i, { level: "body-sm", startDecorator: /* @__PURE__ */ o.jsx("b", { children: "Value:" }), textColor: "inherit", children: Array.isArray(r.values) ? r.values.join(", ") : r.values }) : null
    ] }, `${r.attribute}-${r.condition}-${r.values}`))
  ] }) }),
  s.combine?.map((r, m) => /* @__PURE__ */ o.jsx(e, { gap: 0, children: /* @__PURE__ */ o.jsxs(h, { children: [
    r.operator && /* @__PURE__ */ o.jsx(x, { operator: r.operator }),
    /* @__PURE__ */ o.jsxs(p, { children: [
      /* @__PURE__ */ o.jsx(i, { level: "body-sm", startDecorator: /* @__PURE__ */ o.jsxs("b", { children: [
        "Audience ",
        m + 2,
        ":"
      ] }), textColor: "inherit", children: r.name }),
      r.filters?.filters.map((t, l) => /* @__PURE__ */ o.jsxs(e, { mt: 1, spacing: 0, children: [
        /* @__PURE__ */ o.jsx(i, { level: "body-sm", startDecorator: /* @__PURE__ */ o.jsx("b", { children: "Attribute:" }), textColor: "inherit", children: n(t.attribute ?? "") }),
        /* @__PURE__ */ o.jsx(i, { level: "body-sm", startDecorator: /* @__PURE__ */ o.jsx("b", { children: "Condition:" }), textColor: "inherit", children: (t.condition && a[t.condition]) ?? t.condition }),
        t.values?.length ? /* @__PURE__ */ o.jsx(i, { level: "body-sm", startDecorator: /* @__PURE__ */ o.jsx("b", { children: "Value:" }), textColor: "inherit", children: Array.isArray(t.values) ? t.values.join(", ") : t.values }) : null
      ] }, `${t.attribute}-${t.condition}-${t.values}-${l}`))
    ] })
  ] }) }, m))
] }));
j.displayName = "AudienceSummary";
export {
  j as default
};
//# sourceMappingURL=AudienceSummary.js.map
